module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="header">Remove Incompatible Widgets</div>\n<div class="message-region">\n</div>\n<div class="footer">\n    <div class="remove-widgets-confirm"><button class="btn">Confirm</button></div>\n    <div class="remove-divider">|</div>\n    <div class="remove-widgets-cancel">Cancel</div>\n</div>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/editor/email/RemoveIncompatibleWidgetsContentView.tpl
// module id = 1775
// module chunks = 0